import { render, staticRenderFns } from "./TitleText.vue?vue&type=template&id=73bf8acc&scoped=true"
import script from "./TitleText.vue?vue&type=script&lang=js"
export * from "./TitleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf8acc",
  null
  
)

export default component.exports